export default __webpack_public_path__ + "static/media/expand-selected.085937d2.svg";